module.exports = __webpack_public_path__ + "img/UserOperations.cc72aa1a.svg";